import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { Tabs } from '../../components/ui/Tabs';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { Button } from '../../components/ui/Button';
import { MessageBar } from '../../components/ui/MessageBar';
import { Timeline } from '../../components/ui/Timeline';
import { TagIcon, DownloadIcon, UploadIcon, ArrowLeftIcon } from 'lucide-react';
const events = [{
  id: 'RFQ-2026-015',
  title: 'Organic Fresh Produce Q3 2026',
  type: 'RFQ',
  deadline: '2026-03-25',
  status: 'Open'
}, {
  id: 'RFP-2025-089',
  title: 'Cold Chain Logistics Services',
  type: 'RFP',
  deadline: '2025-11-30',
  status: 'Awarded'
}, {
  id: 'RFI-2025-042',
  title: 'Sustainable Packaging Alternatives',
  type: 'RFI',
  deadline: '2025-08-15',
  status: 'Closed'
}];
export const SourcingEventsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('active');
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  if (selectedEvent) {
    return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1757">
        <Button variant="ghost" leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-1759" />} onClick={() => setSelectedEvent(null)} className="-ml-4" data-id="element-1758">
          Back to Events
        </Button>
        <PageHeader title={selectedEvent.title} description={`Event ID: ${selectedEvent.id} • Type: ${selectedEvent.type}`} primaryAction={<Button variant="primary" data-id="element-1761">Submit Response</Button>} secondaryActions={<Button variant="secondary" leftIcon={<DownloadIcon className="w-4 h-4" data-id="element-1763" />} data-id="element-1762">
              Download Pack
            </Button>} data-id="element-1760" />

        <MessageBar type="info" title="Response Required" data-id="element-1764">
          Please submit your pricing and technical response before{' '}
          {selectedEvent.deadline}.
        </MessageBar>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1765">
          <div className="lg:col-span-2 space-y-6" data-id="element-1766">
            <Card data-id="element-1767">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1768">
                Event Details
              </h2>
              <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-1769">
                <div data-id="element-1770">
                  <span className="text-text-secondary block" data-id="element-1771">Buyer</span>
                  <span className="font-medium" data-id="element-1772">Rachel Tan</span>
                </div>
                <div data-id="element-1773">
                  <span className="text-text-secondary block" data-id="element-1774">Department</span>
                  <span className="font-medium" data-id="element-1775">Fresh Procurement</span>
                </div>
                <div data-id="element-1776">
                  <span className="text-text-secondary block" data-id="element-1777">Currency</span>
                  <span className="font-medium" data-id="element-1778">SGD</span>
                </div>
                <div data-id="element-1779">
                  <span className="text-text-secondary block" data-id="element-1780">
                    Delivery Terms
                  </span>
                  <span className="font-medium" data-id="element-1781">DDP Singapore</span>
                </div>
              </div>
              <div className="mt-6" data-id="element-1782">
                <h3 className="font-medium mb-2" data-id="element-1783">Description</h3>
                <p className="text-sm text-text-secondary" data-id="element-1784">
                  FairPrice Group is seeking proposals for the supply of organic
                  fresh produce for Q3 2026. This includes leafy greens, root
                  vegetables, and seasonal fruits. Suppliers must hold valid
                  organic certifications.
                </p>
              </div>
            </Card>

            <Card data-id="element-1785">
              <div className="flex justify-between items-center mb-4" data-id="element-1786">
                <h2 className="text-lg font-semibold text-text-primary" data-id="element-1787">
                  Line Items
                </h2>
              </div>
              <DataTable data={[{
              line: 1,
              item: 'Organic Spinach',
              qty: '5,000 KG',
              target: 'SGD 4.50/KG'
            }, {
              line: 2,
              item: 'Organic Carrots',
              qty: '10,000 KG',
              target: 'SGD 2.20/KG'
            }]} columns={[{
              header: 'Line',
              accessorKey: 'line'
            }, {
              header: 'Item Description',
              accessorKey: 'item'
            }, {
              header: 'Quantity',
              accessorKey: 'qty'
            }, {
              header: 'Target Price',
              accessorKey: 'target'
            }]} data-id="element-1788" />
            </Card>
          </div>

          <div className="space-y-6" data-id="element-1789">
            <Card data-id="element-1790">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1791">
                Event Timeline
              </h2>
              <Timeline items={[{
              id: '1',
              title: 'Event Published',
              timestamp: 'Mar 10, 2026',
              status: 'success'
            }, {
              id: '2',
              title: 'Q&A Deadline',
              timestamp: 'Mar 18, 2026',
              status: 'info'
            }, {
              id: '3',
              title: 'Submission Deadline',
              timestamp: 'Mar 25, 2026',
              status: 'warning'
            }, {
              id: '4',
              title: 'Award Decision',
              timestamp: 'Apr 05, 2026',
              status: 'default'
            }]} data-id="element-1792" />
            </Card>

            <Card data-id="element-1793">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1794">
                My Response
              </h2>
              <div className="text-center p-6 border-2 border-dashed border-border-strong rounded-fluent bg-surface-secondary" data-id="element-1795">
                <UploadIcon className="w-8 h-8 text-text-tertiary mx-auto mb-2" data-id="element-1796" />
                <p className="text-sm text-text-secondary mb-4" data-id="element-1797">
                  No response submitted yet.
                </p>
                <Button variant="secondary" size="sm" data-id="element-1798">
                  Upload Proposal
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>;
  }
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1799">
      <PageHeader title="Sourcing Events" description="Participate in active RFIs, RFPs, and RFQs." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Sourcing Events'
    }]} data-id="element-1800" />

      <Card noPadding data-id="element-1801">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-1802">
          <Tabs tabs={[{
          id: 'active',
          label: 'Active Events',
          count: 1
        }, {
          id: 'closed',
          label: 'Closed Events'
        }, {
          id: 'awarded',
          label: 'Awarded to Me',
          count: 1
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1803" />
        </div>
        <div className="p-6" data-id="element-1804">
          <DataTable data={events.filter(e => activeTab === 'active' ? e.status === 'Open' : activeTab === 'awarded' ? e.status === 'Awarded' : e.status === 'Closed')} columns={[{
          header: 'Event ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-1806">{row.id}</span>
        }, {
          header: 'Title',
          accessorKey: 'title'
        }, {
          header: 'Type',
          cell: row => <span className="text-xs font-medium bg-surface-secondary px-2 py-1 rounded" data-id="element-1807">
                    {row.type}
                  </span>
        }, {
          header: 'Deadline',
          accessorKey: 'deadline'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-1808" />
        }]} onRowClick={setSelectedEvent} data-id="element-1805" />
        </div>
      </Card>
    </div>;
};